import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae8f74e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "saas-content-wrap" }
const _hoisted_2 = { class: "saas-content" }
const _hoisted_3 = { class: "saas-content-text margin-l-r" }
const _hoisted_4 = { class: "saas-content-text second margin-l-r" }

import {SaasCards, SaasInteractiveBlock} from "@/features";
import {useLocalizationStore} from "@/shared";
import {WrapTitle} from "@/entities";


export default /*#__PURE__*/_defineComponent({
  __name: 'saas-content',
  setup(__props) {

const {translate} = useLocalizationStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(WrapTitle), {
        text: _unref(translate)('saas_page_title'),
        class: "saas-content-title margin-l-r",
        size: "regular",
        weight: "700"
      }, null, 8, ["text"]),
      _createVNode(_unref(SaasInteractiveBlock), { class: "saas-content-interactive-block" }),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(translate)("our_software_as_a_service")), 1),
      _createVNode(_unref(SaasCards), { class: "saas-content-cards margin-l-r" }),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(translate)("our_services_are_hosted")), 1),
      _createVNode(_unref(WrapTitle), {
        text: _unref(translate)('choose_our_fintech_solutions'),
        class: "margin-l-r",
        size: "regular",
        weight: "700"
      }, null, 8, ["text"])
    ])
  ]))
}
}

})